<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>
<app-cc-form-dialog #ccFlexAddFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="false"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue"
                    [submitButtonLabel]="'common.dialog.save'|translate"
                    dialogClass="cc-dialog-lg allocation-dialog"
                    (close)="closeDialog()"
>
  <app-clearing-selection-summary footer-left [summaryBuyValue]="summaryBuyValue" [summarySellValue]="summarySellValue"
                                  [showLoadingSpinner]="false"></app-clearing-selection-summary></app-cc-form-dialog>

